import React from 'react';
import { useLocation } from 'react-router-dom';
import { APP_NAME, POWERED_BY, useRouteTitle } from '../../branding';

export const RouteTitle = () => {
    useRouteTitle();
    return null;
};

export const PoweredBy = ({ className = '', style }) => (
    <div className={`vp-powered-by ${className}`.trim()} style={style} data-testid="powered-by">{POWERED_BY}</div>
);

// The landing page and sign-in pages carry their own branding.
const OWN_FOOTER = /^\/($|login\/?$|auth(\/|$))/i;

export const SiteFooter = () => {
    const { pathname } = useLocation();
    if (OWN_FOOTER.test(pathname)) return null;
    return (
        <footer className="vp-site-footer" data-testid="site-footer">
            {APP_NAME} &middot; {POWERED_BY}
        </footer>
    );
};
